<template>

    <div>

        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 历史处方
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-input v-model="query.patientName" placeholder="患者" class="handle-input mr10"
                          size="mini "></el-input>
                <el-input v-model="query.mobile" placeholder="手机号" class="phone-input mr10"
                          size="mini "></el-input>
                <el-input v-model="query.patientId" placeholder="处方编号" class="phone-input mr10"
                          size="mini "></el-input>
                <el-button type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
            </div>
            <el-table
                    :data="tableData"
                    border
                    class="table"
                    ref="multipleTable"
                    header-cell-class-name="table-header">
                <el-table-column prop="orderId" label="订单编号" align="center"></el-table-column>
                <el-table-column prop="patientName" label="姓名" align="center"></el-table-column>
                <el-table-column prop="sex" label="性别" align="center"></el-table-column>
                <el-table-column prop="age" label="年龄" align="center"></el-table-column>
                <el-table-column prop="mobile" label="手机" align="center"></el-table-column>
                <el-table-column prop="nTime" label="开方时间" width="180px" align="center"></el-table-column>
                <el-table-column prop="prescriptionType" label="处方类型" align="center"></el-table-column>
                <el-table-column prop="paymentAmount" label="金额" align="center"></el-table-column>
                <el-table-column prop="paymentStatus" label="收款状态" align="center"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :page-sizes="pages"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>


    </div>
</template>
<script>
    export default {
        data() {
            return {
                pageNum: 1,
                pageSize: 10,
                total: 1,
                pages: 1,
                tableData: {
                    CostList: {
                        orderId: '',
                        patientName: '',
                        age: '',
                        sex: '',
                        mobile: '',
                        prescriptionTime: '',
                        prescriptionType: '',
                        drugCost: '',
                        diagnoseCost: '',
                        freight: '',
                        paymentType: '',
                        paymentAmount: '',
                        cost: '',
                        status: '',
                        remark: '',
                        paymentTime: '',
                        tTime: '',
                        nTime:'',
                        paymentStatus: ''
                    }
                }
                , query: {
                    orderId: '',
                    patientName: '',
                    age: '',
                    sex: '',
                    mobile: '',
                    prescriptionTime: '',
                    prescriptionType: '',
                    drugCost: '',
                    diagnoseCost: '',
                    freight: '',
                    paymentType: '',
                    paymentAmount: '',
                    cost: '',
                    status: '',
                    remark: '',
                    paymentTime: '',
                    tTime: '',
                    nTime:'',
                    paymentStatus: ''
                },
            };
        },
        created() {

            this.getData();
        },
        methods: {

            getData() {
                this.axios.post('/order/' + this.pageNum + "/" + this.pageSize, this.query).then((res) => {
                    if (res.data.data.list != null) {
                        var data = res.data.data;
                        this.tableData = data.list;
                        this.pageNum = data.pageNum;
                        this.pageSize = data.pageSize;
                        this.total = data.total;
                        this.pages = data.total;
                    } else {
                        this.$message.success("暂无数据");
                    }
                })
            },
            // 触发搜索按钮
            handleSearch() {
                this.getData();
            }
            ,
            // 保存编辑
            // 分页导航
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            }
        }
    };
</script>

<style scoped>

    table {
        border-collapse: collapse;
    }

    td {
        border: #000 1px solid;
        width: 100px;
        text-align: center;
    }

    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 100px;
        display: inline-block;
    }

    .phone-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }


    .mr10 {
        margin-right: 10px;
    }


</style>
